import React, { useEffect, useState } from "react";
import Loader from "../Common/Loader/Loader";
import withStyles from "isomorphic-style-loader/withStyles";
import {
    CardNumberElement,
    CardCvcElement,
    CardExpiryElement,
} from '@stripe/react-stripe-js'
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import cx from "classnames"
import { FormattedMessage } from "react-intl";
import { Button } from 'react-bootstrap';

import SelectFieldComponent from "../Common/SelectFieldComponent/SelectFieldComponent";
import InputFieldComponent from "../Common/InputFieldComponent/InputFieldComponent";

import validate from "./validate";


import { setLoaderStart, setLoaderComplete } from "../../actions/loader/loader";
import { addCardDetailsAction } from "../../actions/payment/addCardDetailsAction";
import { addWalletDetails } from "../../actions/wallet/addWalletDetials";

import history from "../../history";
import messages from "../../locale/messages";
import { isRTL } from '../../helpers/formatLocale';
import showToaster from "../../helpers/toastrMessgaes/showToaster";
import { getCurrencySymbol } from "../../helpers/currencyConvertion";
import CurrencyConverter from "../CurrencyConverter/CurrencyConverter";
import RadioFieldComponent from "../Common/RadioFieldComponent/RadioFieldComponent";
import PaymentCardSkeleton from "../Skeleton/ViewBooking/PaymentCardSkeleton/PaymentCardSkeleton";

import stripeIcon from '/public/dashboard/stripeIcon.svg';
import Visa from '/public/Icons/visa.svg';
import MasterCard from '/public/Icons/masterCard.svg';
import AmericanExpress from '/public/Icons/american-express.svg';
import Discover from '/public/Icons/discover.svg';
import stripeLogo from '../../../public/Icons/stripe.png';
import paypalIcon from '../../../public/Icons/paypal.png';
import walletIcon from '../../../public/Icons/wallet.png';

import { DARK_MODE_PRIMARY_FOREGROUND, DARK_MODE_PRIMARY_PLACEHOLDER, LIGHT_MODE_PRIMARY_FOREGROUND, LIGHT_MODE_PRIMARY_PLACEHOLDER } from "../../constants";

import bt from '../commonStyle.css';
import cs from '../../styles/stripeCardElement.css'
import s from "./CardForm.css";


const createOptions = (theme, isRTLLocale, placeholder) => {
    return {
        style: {
            base: {
                color: theme == "dark" ? DARK_MODE_PRIMARY_FOREGROUND : LIGHT_MODE_PRIMARY_FOREGROUND,
                fontWeight: 400,
                fontSize: "16px",
                fontFamily: "inherit",
                lineHeight: '26px',
                textAlign: isRTLLocale ? "right" : "left",
                fontSmoothing: "antialiased",
                ":focus": {
                    color: theme == "dark" ? DARK_MODE_PRIMARY_FOREGROUND : LIGHT_MODE_PRIMARY_FOREGROUND,
                },

                "::placeholder": {
                    color: theme == "dark" ? DARK_MODE_PRIMARY_PLACEHOLDER : LIGHT_MODE_PRIMARY_PLACEHOLDER,
                },

                ":focus::placeholder": {
                    color: theme == "dark" ? DARK_MODE_PRIMARY_PLACEHOLDER : LIGHT_MODE_PRIMARY_PLACEHOLDER,
                },
            },
            invalid: {
                color: theme == "dark" ? DARK_MODE_PRIMARY_FOREGROUND : LIGHT_MODE_PRIMARY_FOREGROUND,
                ":focus": {
                    color: theme == "dark" ? DARK_MODE_PRIMARY_FOREGROUND : LIGHT_MODE_PRIMARY_FOREGROUND,
                },
                "::placeholder": {
                    color: theme == "dark" ? DARK_MODE_PRIMARY_PLACEHOLDER : LIGHT_MODE_PRIMARY_PLACEHOLDER,
                },
            },
        },
        placeholder: placeholder
    };
};

function CardForm(props) {
    const {
        stripe,
        elements,
        loading,
        isWallet,
        currency,
        theme,
        locale,
        setLoaderStart,
        setLoaderComplete,
        addCardDetailsAction,
        addWalletDetails,
        intl: { formatMessage },
        handleSubmit,
        enabledPaymentMethods,
        isPaymentId,
        currencyList,
        orderId,
        amount,
        bookingId,
        paymentMethodLoading
    } = props

    const [load, setLoad] = useState(false);
    const [paymentType, setPaymentType] = useState('')

    useEffect(() => {
        isPaymentId && setPaymentType(isPaymentId)
    }, [isPaymentId])

    useEffect(() => {
        setTimeout(() => {
            paymentMethodLoading ? setLoad(false) : setLoad(true);
        }, 200);
    },)
    const submitHandler = async (values) => {
        if (paymentType == 2) {
            let createPaymentMethod, paymentMethodId, errorMessage, cardLastFour;
            setLoaderStart('addCardDetails');

            if (!stripe || !elements) return;

            const card = elements.getElement(CardNumberElement);

            if (card == null) return;

            createPaymentMethod = await stripe.createPaymentMethod({
                type: 'card',
                card
            })

            if (createPaymentMethod?.paymentMethod) {
                paymentMethodId = createPaymentMethod?.paymentMethod?.id;
                cardLastFour = createPaymentMethod?.paymentMethod?.card?.last4;

                if (!isWallet) {
                    await addCardDetailsAction({ stripe, paymentMethodId, cardLastFour, orderId, bookingId });
                } else {
                    await addWalletDetails({ stripe, amount: values?.walletBalance, currency, paymentMethodId, cardLastFour, paymentType, orderId, bookingId })
                }
            }

            if (createPaymentMethod?.error?.message) {
                errorMessage = createPaymentMethod?.error?.message;
                showToaster({ messageId: 'catchMessage', requestContent: errorMessage, toasterType: 'error' });
                setLoaderComplete('addCardDetails');
            }
        } else if (paymentType == 5) {
            if (!values?.paypalCurrency) {
                showToaster({ messageId: 'selectCurrency', toasterType: 'error' });
                return;
            }
            setLoaderStart('addCardDetails')
            await addWalletDetails({ stripe, amount: values?.walletBalance, currency, paymentCurrency: values?.paypalCurrency, paymentType, orderId, bookingId })
            setLoaderComplete('addCardDetails');
        }
    }
    const handleCancel = () => {
        orderId
            ? history.push(`/order/${orderId}`)
            : (bookingId
                ? history.push(`/tracking/${bookingId}`)
                : history.push('/payment-method'));
    }

    const handleRadioChange = async (event) => {
        setPaymentType(event.target.value)
    };

    let rows = [{ value: '', label: formatMessage(messages.chooseCurrency) }];

    if (currencyList != null && currencyList?.length > 0) {
        currencyList?.map((item, index) => {
            if (item?.isEnable && item?.isPayment) {
                rows.push({
                    value: item?.symbol,
                    label: item?.symbol
                }
                );
            }
        });
    }
    let symbol = getCurrencySymbol(currency);

    if (!load) {
        return <PaymentCardSkeleton />

    }

    return (
        <form onSubmit={handleSubmit(submitHandler)}>
            <div className={s.paymentCardInnerBox}>
                {load && isWallet &&
                    <div className={s.walletAmountRow}>
                        <div className={s.paymentChooseTabRow}>
                            {enabledPaymentMethods.find(o => o.id === 2) &&
                                <div className={cx(s.paymentTab, paymentType == '2' && s.isActivePaymentTab)}>
                                    <span className={s.tabLabelGroup}>
                                        <img src={stripeLogo} alt="stripeLogo" />
                                        <FormattedMessage {...messages.stripeLabel} />
                                    </span>
                                    <RadioFieldComponent
                                        name="paymentType"
                                        value="2"
                                        onChange={(e) => handleRadioChange(e)}
                                        size={18}
                                        isTick />
                                </div>}

                            {enabledPaymentMethods.find(o => o.id === 5) &&
                                <div className={cx(s.paymentTab, paymentType == '5' && s.isActivePaymentTab)}>
                                    <span className={s.tabLabelGroup}>
                                        <img src={paypalIcon} alt="paypalIcon" />
                                        <FormattedMessage {...messages.paypalLabel} />
                                    </span>
                                    <RadioFieldComponent
                                        name="paymentType"
                                        value="5"
                                        onChange={(e) => handleRadioChange(e)}
                                        size={18}
                                        isTick />
                                </div>}
                        </div>
                        <div className={s.totalWalletAmount}>
                            <img src={walletIcon} alt="walletIcon" />
                            <FormattedMessage {...messages.walletLabel} />
                            <CurrencyConverter amount={amount} from={currency} />
                        </div>
                    </div>}

                {load &&
                    <div className="oneColumnGrid">
                        <div className='twoColumnGrid'>
                            {isWallet &&
                                <Field
                                    name="walletBalance"
                                    type="text"
                                    placeholder={formatMessage(messages.walletAmountText)}
                                    component={InputFieldComponent}
                                    label={formatMessage(messages.amount)}
                                    autoFocus={true}
                                    isAddon
                                    suffixLabel={symbol}
                                />}

                            {paymentType == 2 &&
                                <div>
                                    <p className={cx(bt.commonLabelText)}><FormattedMessage {...messages.creditOrDebitNumber} /> </p>
                                    <CardNumberElement
                                        options={createOptions(theme, isRTL(locale), "4242 4242 4242 4242")}
                                        className={cx("cardSectionField", "cardSectionFieldOne")} />
                                </div>}

                            {paymentType == 5 &&
                                <Field
                                    name="paypalCurrency"
                                    component={SelectFieldComponent}
                                    options={rows}
                                    label={formatMessage(messages.currency)}
                                    inputClass={bt.formControlSelect}
                                />
                            }
                        </div>

                        {paymentType == 2 &&
                            <div className="oneColumnGrid">
                                <div className='twoColumnGrid'>
                                    <div>
                                        <p className={cx(bt.commonLabelText)}><FormattedMessage {...messages.cardExpires} /></p>
                                        <CardExpiryElement
                                            options={createOptions(theme, isRTL(locale), "MM / YY")}
                                            className={cx("cardSectionField", "cardSectionFieldTwo")} />
                                    </div>

                                    <div>
                                        <p className={cx(bt.commonLabelText)}><FormattedMessage {...messages.cvv} /></p>
                                        <CardCvcElement
                                            options={createOptions(theme, isRTL(locale), "_ _ _")}
                                            className={cx("cardSectionField", "cardSectionFieldThree")}
                                        />
                                    </div>
                                </div>

                                <div className={s.paymentIconRow}>
                                    <div className={s.paymentIconList}>
                                        {[Visa, MasterCard, AmericanExpress, Discover].map((item, index) => {
                                            return (
                                                <img key={index} src={item} alt='payment' />
                                            )
                                        })}
                                    </div>
                                    <img src={stripeIcon} alt="Stripe" className={s.poweredStripeIcon} />
                                </div>
                            </div>}
                    </div>
                }
            </div>

            {load &&
                <div className={cx('commonButtonContainer')}>
                    <Button onClick={handleCancel} className={bt.btnSecondary}><FormattedMessage {...messages.cancelButton} /></Button>
                    <Loader
                        type={"button"}
                        buttonType={"submit"}
                        show={loading}
                        label={formatMessage(messages.add)}
                        className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                    />
                </div>}
        </form>
    )
}

CardForm = reduxForm({
    form: "CardForm",
    validate
})(CardForm);

const mapState = (state) => ({
    loading: state?.loader?.addCardDetails,
    currency: state?.userAccount?.data?.preferredCurrency,
    theme: state.currency.theme,
    locale: state.intl.locale,
    currencyList: state?.currency?.availableCurrencies,
})
const mapDispatch = {
    setLoaderStart,
    setLoaderComplete,
    addCardDetailsAction,
    addWalletDetails
}
export default injectIntl(withStyles(bt, cs, s)(connect(mapState, mapDispatch)(CardForm)));